<template>
  <v-bottom-navigation
    fixed
    scroll-threshold="500"
    height="96"
    style="box-shadow: none"
  >
    <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
      <v-col cols="12">
        <v-btn
          block
          elevation="0"
          class="btn-fixed"
          color="deepGrey"
          @click="$emit('next')"
          ><span class="white--text">다음</span></v-btn
        >
      </v-col>
    </v-row>
  </v-bottom-navigation>
</template>

<script>
export default {};
</script>

<style></style>
